import { render } from "./DataEntry.vue?vue&type=template&id=0d0c9804&scoped=true"
import script from "./DataEntry.vue?vue&type=script&lang=js"
export * from "./DataEntry.vue?vue&type=script&lang=js"

import "./DataEntry.vue?vue&type=style&index=0&id=0d0c9804&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0c9804"]])

export default __exports__